import { createAsyncThunk } from '@reduxjs/toolkit'
import { ServiceConfig } from '../../services/config'
import { APIError, get, post } from '../../services/crud'
import { IUserPreferenceGeneralListItem } from './typings'

const baseUrl = `${ServiceConfig.baseAPIUrl}/UserPreferences`

export const loadGeneralPreferences = createAsyncThunk<
  IUserPreferenceGeneralListItem[],
  void,
  { rejectValue: APIError }
>('userPreferences/general/load', async (_, thunkApi) => {
  const response = await get(`${baseUrl}/general`)

  if (response.ok) return await response.json()
  return thunkApi.rejectWithValue(await response.json())
})

export const loadGeneralPreferencesByType = createAsyncThunk<
  IUserPreferenceGeneralListItem[],
  void,
  { rejectValue: APIError }
>('userPreferences/general/loadByType', async (type, thunkApi) => {
  const response = await get(`${baseUrl}/general/type/${type}`)

  if (response.ok) return await response.json()
  return thunkApi.rejectWithValue(await response.json())
})

export const saveGeneralPreferences = createAsyncThunk<
  IUserPreferenceGeneralListItem,
  IUserPreferenceGeneralListItem,
  { rejectValue: APIError }
>('userPreferences/general/save', async (pref, thunkApi) => {
  const response = await post(`${baseUrl}/general`, pref)

  if (response.ok) return await response.json()
  return thunkApi.rejectWithValue(await response.json())
})
export const saveGeneralPreferencesBatch = createAsyncThunk<
  IUserPreferenceGeneralListItem[],
  IUserPreferenceGeneralListItem[],
  { rejectValue: APIError }
>('userPreferences/general/batch/save', async (pref, thunkApi) => {
  const response = await post(`${baseUrl}/general/batch`, pref)

  if (response.ok) return await response.json()
  return thunkApi.rejectWithValue(await response.json())
})
